<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtros
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Status</label>
          <v-select
            id="filter-Status-usuario"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Período de cadastro</label>
          <div class="d-flex align-items-center">
            <input
              type="date"
              v-model="dateStartLocal"
              class="form-control w-50 mr-1"
              placeholder="Data inicial"
              @change="onDateRangeChange"
              @blur="onDateRangeChange"
            >
            <span class="mx-1">até</span>
            <input
              type="date"
              v-model="dateEndLocal"
              class="form-control w-50 ml-1"
              placeholder="Data final"
              @change="onDateRangeChange"
              @blur="onDateRangeChange"
            >
            <b-button
              v-if="dateStartLocal || dateEndLocal"
              variant="outline-secondary"
              size="sm"
              class="ml-2"
              @click="clearDateRange"
              title="Limpar datas"
            >
              <span aria-hidden="true">X</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    statusFilter: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    dateStart: {
      type: [String, null],
      default: null,
    },
    dateEnd: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      dateStartLocal: this.dateStart,
      dateEndLocal: this.dateEnd,
    }
  },
  watch: {
    dateStart(val) {
      this.dateStartLocal = val
    },
    dateEnd(val) {
      this.dateEndLocal = val
    },
  },
  methods: {
    onDateRangeChange() {
      this.$emit('update:dateStart', this.dateStartLocal)
      this.$emit('update:dateEnd', this.dateEndLocal)
    },
    clearDateRange() {
      this.dateStartLocal = null
      this.dateEndLocal = null
      this.onDateRangeChange()
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}/${month}/${year}`
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>